enum EContactUsStatus {
    
    NEW             = 1,
    READED          = 2,
    RESPONDED       = 4,
    FLAGED          = 8,
    KEEP_AT_TOP     = 16,
    DELETED         = 32
    
}


export default EContactUsStatus;
